import axios, { baseURL } from '@axios'
import { paginateArray, sortCompare } from '@/common'
import { getUserData } from '@/auth/utils'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchUsers(ctx, queryParams) {

      return new Promise((resolve, reject) => {
        axios
          .get(`${baseURL}/api/Contact/Get`)
          .then(response => {
            const {
            q = '',
            perPage = 10,
            page = 1,
            sortBy = '',
            sortDesc = false,
            status,
            plan
          } = queryParams

          const queryLowered = q.toLowerCase()
          var dataFromAPI = response.data.data
     
          if (status) {
            dataFromAPI = dataFromAPI.filter(user => user.active == (status == "active" ? true : false))
          }
          // contactType
          if (plan) {
            dataFromAPI = dataFromAPI.filter(user => user.contactType == plan)
          }

          if (q && q.length > 2) {
            dataFromAPI = dataFromAPI.filter(user => user.contactName.includes(q))
          }

          const filteredData = dataFromAPI.filter(
            user =>
              /* eslint-disable operator-linebreak, implicit-arrow-linebreak */
              user.contactName
          )

          const sortedData = filteredData.sort(sortCompare(sortBy))
          if (sortDesc) sortedData.reverse()

          resolve({
            data: paginateArray(sortedData, perPage, page),
            totalCount: filteredData.length,
          })})
          .catch(error => reject(error))
      })
    },
    fetchUser(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${baseURL}/api/Contact/GetById`, {
            params: {
              contactId: id,
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchUserOld(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/apps/user/users/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addUser(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${baseURL}/api/User/AddOrUdpate`, { userData })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteUser(ctx, { id, status }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`${baseURL}/api/Contact/Delete`, {
            params: {
              contactId: id,
              status
            }})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchProducts(ctx, queryParams) {
      const userData = getUserData()

      return new Promise((resolve, reject) => {
        const body = {
          pagination: {
            total: 0,
            current: 0,
            pageSize: 0,
            // current: queryParams.page,
            // pageSize: queryParams.perPage,
          },
          search: {
            startPrice: null,
            endPrice: null,
            shopId: userData.shopId,
            categoryId: null,
            hasOptions: null,
            isVisibleIndividually: null,
            isFeatured: null,
            isAllowToOrder: null,
            isPublished: null,
            isChecking: null,
            isViolation: null,
            sku: null,
            categoryIds: [

            ],
            includeSubCategories: true,
            outOfStock: null,
            isActive: false
          },
          sort: {
            predicate: 'created_date',
            // predicate: queryParams.sortBy,
            reverse: true,
          },
        }

        axios
          .post(`${baseURL}/api/Product/GetList`, body, {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              Authorization: `Bearer ${userData.token}`,
            },
          })
          .then(response => {

            console.log(response)

            const {
              q = '',
              perPage = 10,
              page = 1,
              sortBy = 'id',
              sortDesc = false,
              productName = null,
              productCategory = null,
              status = null,
            } = queryParams

            // const queryLowered = q.toLowerCase()
            const filteredData = response.data.data.list
  
            // const filteredData = response.data.data.filter(
            //   product =>
            //     /* eslint-disable operator-linebreak, implicit-arrow-linebreak */
            //     (product.productId.toLowerCase().includes(queryLowered) || product.productName.toLowerCase().includes(queryLowered) ||
            //     product.productCategory.toLowerCase().includes(queryLowered) || product.price.toString().toLowerCase().includes(queryLowered) ||
            //     product.qtyInStock.toString().toLowerCase().includes(queryLowered)) &&
            //     product.productName === (productName || product.productName) &&
            //     product.productCategory === (productCategory || product.productCategory) &&
            //     product.status === (status || product.status),
            // )

            // const sortedData = filteredData.sort(sortCompare(sortBy))
            // if (sortDesc) sortedData.reverse()

            resolve({
              products: paginateArray(filteredData, perPage, page),
              total: filteredData.length,
            })
          })
          .catch(error => reject(error))
      })
    },
  },
}
